import React, { createContext, useContext, useState, useEffect } from 'react';
import alertsService from '../services/alertsService';

const AlertsContext = createContext();

export const useAlerts = () => {
  const context = useContext(AlertsContext);
  if (!context) {
    throw new Error('useAlerts must be used within an AlertsProvider');
  }
  return context;
};

export const AlertsProvider = ({ children }) => {
  const [myAlerts,     setMyAlerts]     = useState([]);
  const [nearbyAlerts, setNearbyAlerts] = useState([]);

  const refreshAlerts = () => {
    alertsService.getAlerts().then(({ myAlerts: mine, nearbyAlerts: nearby }) => {
      console.debug('[AlertsContext] fetched — mine:', mine.length, 'nearby:', nearby.length);
      setMyAlerts(mine);
      setNearbyAlerts(nearby);
    });
  };

  // Populate from the server on mount
  useEffect(() => { refreshAlerts(); }, []); // eslint-disable-line react-hooks/exhaustive-deps

  /** Called by CreateAlert after a successful POST — optimistically prepends to myAlerts. */
  const addAlert = (newAlert) => {
    const alert = {
      issueDate: new Date().toLocaleString(),
      time: 'Just now',
      status: 'active',
      coordinates: newAlert.coordinates || null,
      ...newAlert,
      id: newAlert.id ?? Date.now(),
    };
    setMyAlerts(prev => [alert, ...prev]);
  };

  /** Closes one of the user's own alerts and records the reason (owner-only action). */
  const deleteAlert = async (alertId, reason) => {
    await alertsService.deleteAlert(alertId, reason);
    setMyAlerts(prev => prev.filter(a => a.id !== alertId));
  };

  return (
    <AlertsContext.Provider value={{ myAlerts, nearbyAlerts, addAlert, deleteAlert, refreshAlerts }}>
      {children}
    </AlertsContext.Provider>
  );
};
